import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "aside-logo-menu" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoComponent = _resolveComponent("LogoComponent")!
  const _component_MenuComponent = _resolveComponent("MenuComponent")!
  const _component_ContactComponent = _resolveComponent("ContactComponent")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["main-sidebar", {'active': _ctx.active, 'slide-out': !_ctx.active, 'large': _ctx.isLocal || _ctx.isEmployer}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_LogoComponent),
      _createVNode(_component_MenuComponent, { onOpenMenu: _ctx.openMenu }, null, 8, ["onOpenMenu"])
    ]),
    _hoisted_2,
    _createVNode(_component_ContactComponent)
  ], 2))
}